import { Component, OnInit, Inject, Output, EventEmitter} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FollowUpService } from './follow-up.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import moment from 'moment';


@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.css']
})
export class FollowUpComponent implements OnInit {
  @Output() successfulSubmission: EventEmitter<any> = new EventEmitter<any>();
  followUpForm!: FormGroup;
  masters: any = [];
  followUpReason: any = [];
  leadStage: any = [];
  submitted = false;
  leadId: any;
  isLoading: Subject<boolean> = new Subject<boolean>();
  minDate: any =new Date();


  constructor(public dialogRef: MatDialogRef<FollowUpComponent>,
    private fb: FormBuilder, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private followUpService: FollowUpService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.leadId = this.data.leadId;
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');

    if (masters) {
      this.masters = masters;
      this.followUpReason = this.masters.followUpReason || [];
      this.leadStage = this.masters.leadStage || [];
      
    }

    this.followUpForm = this.fb.group({
      stage_id: ['2:Follow Up'],
      followup_reason: ['', Validators.required],
      followup_date: ['', Validators.required],
      timeOfFollowUp: ['', Validators.required],
      remarks: [''],
      id: [this.leadId],
    });
  }

  get f() {
    return  this.followUpForm.controls
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.submitted = true
		if (!this.followUpForm.valid) {
    return;
    }else{
      this.isLoading = new BehaviorSubject<boolean>(true);
      const followUpdata: any = this.followUpForm.value;
      const date = this.followUpForm.get('followup_date')?.value;
      const time = moment(this.followUpForm.get('timeOfFollowUp')?.value, ['h:mm A']).format('HH:mm');
      // const formattedDate = new Date(date).toISOString().split('T')[0];
      const formattedDate = moment(date).format('YYYY-MM-DD');
      const followupDateTime = `${formattedDate} ${time}`;
      const utcDateTime = moment(followupDateTime, 'YYYY-MM-DD HH:mm').utc().format();
      
      const formData = { ...this.followUpForm.value, followup_date: utcDateTime };
  
 
			this.followUpService.followUp(formData).subscribe((response: any) => {
				let responseData = response.body;
				if (responseData.responseCode == 200) {
          this.successfulSubmission.emit();
          this.dialogRef.close(formData);
          this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.success("Lead Moved to Follow Up successfully!")
				} else {
          this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.error(responseData.responseMessage)
				}
			}, (err: any) => {
				this.isLoading = new BehaviorSubject<boolean>(false);
			});
		}
  }
  
  
}